module.exports = __webpack_public_path__ + "static/MainBgImage-15d78eca64aab7515c02dab20c97072e.jpg";